import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import { useIntl } from "react-intl";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import ErrorOutlineRoundedIcon from "@material-ui/icons/ErrorOutlineRounded";
import {
  deletePatientDiseasesService,
  deletePatientSymptomsService,
  deleteRecordService,
  getPatientFamilyBackgroundsService,
  getPatientDiseasesService,
  getPatientService,
  getPatientSymptomsService,
  patchUpdateRecordService,
  postCreateRecordService,
  putUpdatePatientDiseasesService,
  putUpdatePatientSymptomsService,
  getPatientBackgroundsService,
  putUpdateFamilyBackgroundsService,
  deleteFamilyBackgroundsService,
  putUpdatePatientBackgroundsService,
  deletePatientBackgroundsService,
} from "../../services/commonservices";
import {
  storePatientInfoAction,
  storeFamilyBackgroundsActionCreator,
  storePatientBackgroundsActionCreator,
  storePatientDataActionCreator,
  storePatientDiagnosisActionCreator,
  storePatientDiseasesActionCreator,
  storePatientInitialStateActionCreator,
  storePatientSymptomsActionCreator,
  storeSearchPatientIdActionCreator,
} from "../../reducers/patientState";
import iconUserBlue from "../../images/gen/icon-user-blue.svg";
import iconHeartBlue from "../../images/gen/icon-heart-blue.svg";
import iconFamilyBlue from "../../images/gen/icon-family-blue.svg";
import iconDoc from "../../images/gen/icon-doc-blue.svg";
import iconRecord from "../../images/gen/folder-blue.svg";
import PatientInfoComponent from "./components/patientInfoComponent/PatientInfoComponent";
import PatientSymptomsComponent from "./components/patientSymptomsComponent/PatientSymptomsComponent";
import PatientFamilyBackgroundComponent from "./components/patientFamilyBackgroundComponent/PatientFamilyBackgroundComponent";
import PatientDiagnosisComponent from "./components/patientDiagnosisComponent/PatientDiagnosisComponent";
import { useNavigate } from "react-router";
import { HTTP_CODE_409, ROLES_ALL, ROUTES_HOME } from "../../utils/constants";
import FormButtonGroupComponent from "../common/FormButtonGroupComponent";
import withAuthorization from "../common/auth/withAuthorization";
import {
  cancelPatientDiseasesAction,
  cancelPatientSymptomsAction,
  changeFamilyBackgroundsToRemoveAction,
  changeDiseasesToRemoveAction,
  changeSymptomsToRemoveAction,
  resetSelectionAction,
  storeSearchInitialStateActionCreator,
  cancelFamilyBackgroundsAction,
  changePatientBackgroundsToRemoveAction,
  cancelPatientBackgroundsAction,
} from "../../reducers/searchOmimState";
import AlertDialog from "../common/AlertDialog";
import { storeUserFoundActionCreator, storeUserNotFoundActionCreator } from "../../reducers/commonState";
import { PATIENT_SCHEMA, renderFormError } from "./PatientSchema";
import { showMessage } from "../common/NotificationSnack";
import PatientBackgroundsComponent from "./components/patientBackgroundsComponent/PatientBackgroundsComponent";
import BackButtonComponent from "../common/BackButtonComponent";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "1fr 3fr",
    gap: "1rem",
    maxHeight: "calc(100vh - 160px)",
    padding: "1rem",
    overflow: "scroll",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      gridTemplateColumns: "1fr",
    },
  },
  gridItem: {
    maxWidth: "100%",
  },
  tabsPaper: {
    borderRadius: 32,
    gap: "1rem",
    boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    justifyContent: "space-between",
    backgroundColor: "white",
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "1rem",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",
      zIndex: 2,
      borderRadius: 0,
      padding: theme.spacing(1),
      height: "auto",
    },
  },
  tabs: {
    width: "100%",
  },
  tab: {
    width: "100%",
    display: "flex",
    gap: theme.spacing(1.5),
    "& img": {
      width: 15,
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  tabLabel: {
    textTransform: "lowercase !important",
    "&:first-letter": {
      textTransform: "capitalize !important",
    },
  },
  panelPaper: {
    borderRadius: 32,
    boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    padding: "2rem",
    backgroundColor: "white",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    [theme.breakpoints.down("sm")]: {
      borderTopLeftRadius: 32,
      borderBottomLeftRadius: 32,
      boxShadow: "none",
      padding: "1rem",
    },
  },
  backButtonLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    "&:hover": {
      color: `${theme.palette.selected.main} !important`,
    },
  },
  primaryButton: theme.primaryPinkButton,
  secondaryButton: theme.secondaryPinkButton,
  dialogTitle: {
    padding: theme.spacing(2),
    color: theme.palette.secondary.main,
  },
  formError: {
    color: "red !important",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  firstCap: {
    textTransform: "lowercase !important",
    "&:first-letter": {
      textTransform: "capitalize !important",
    },
  },
}));

const PatientComponent = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const navigate = useNavigate();
  const classes = useStyles();
  const { mobileVersion } = useSelector((state) => state.common);

  const [tab, setTab] = useState(0);
  const [disableTabs, setDisableTabs] = useState(true);
  const [openDeleteRecordModal, setOpenDeleteRecordModal] = useState(false);
  const [formError, setFormError] = useState(null);
  const [newPatient, setNewPatient] = useState(false);

  const {
    patientData,
    recordId,
    patientId,
    searchPatientId,
    gender,
    birthDate,
    residentialZipCode,
    birthZipCode,
    comments,
    diagnosis,
    symptoms,
    familyBackgrounds,
    patientBackgrounds,
    diseases,
  } = useSelector((state) => state.patient);

  const {
    selectedSymptoms,
    symptomsToRemove,
    selectedFamilyBackgrounds,
    familyBackgroundsToRemove,
    selectedDiseases,
    diseasesToRemove,
    selectedPatientBackgrounds,
    patientBackgroundsToRemove,
  } = useSelector((state) => state.searchOmim);

  const handleSetOpenDeleteRecordModal = () => {
    setOpenDeleteRecordModal((openDeleteRecordModal) => !openDeleteRecordModal);
  };

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const storagePatientId = localStorage.getItem("genome-patient-id");

  const patientErrorCallback = () => {
    setDisableTabs(true);
  };

  const patientCallback = (response) => {
    if (!response?.data?.length) {
      localStorage.removeItem("genome-patient-id");
      localStorage.removeItem("genome-new-patient");
      dispatch(storeUserNotFoundActionCreator());
      setDisableTabs(true);
      return;
    }

    const record = response.data[0];

    if (!patientId) {
      localStorage.setItem("genome-patient-id", record.patient_id);
      localStorage.setItem("genome-new-patient", JSON.stringify(false));
    }

    dispatch(storeUserFoundActionCreator());
    dispatch(storePatientDataActionCreator(record));
    dispatch(storePatientInfoAction(record));

    !symptoms?.length && getSymptoms(record.id);
    !familyBackgrounds?.length && getFamilyBackgrounds(record.id);
    !diseases?.length && getDiseases(record.id);
    !patientBackgrounds?.length && getPatientBackgrounds(record.id);

    setDisableTabs(false);
  };

  useEffect(() => {
    if (storagePatientId && !searchPatientId) {
      dispatch(storeSearchPatientIdActionCreator(storagePatientId));
    }

    return () => setFormError(null);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!!recordId) {
      setNewPatient(false);
    } else {
      setNewPatient(true);
    }
  }, [recordId]);

  useEffect(() => {
    if (!newPatient && searchPatientId) {
      getPatientService(searchPatientId, patientCallback, patientErrorCallback);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPatientId]);

  useEffect(() => {
    if (!patientData?.id && !disableTabs) {
      setDisableTabs(true);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientData]);

  const getSymptoms = (id) => {
    getPatientSymptomsService(id, getSymptomsCallback);
  };

  const getFamilyBackgrounds = (id) => {
    getPatientFamilyBackgroundsService(id, getFamilyBackgroundsCallback);
  };

  const getDiseases = (id) => {
    getPatientDiseasesService(id, getDiseasesCallback);
  };

  const getPatientBackgrounds = (id) => {
    getPatientBackgroundsService(id, getPatientBackgroundsCallback);
  };

  const handleGoBack = () => {
    localStorage.removeItem("genome-new-patient");
    localStorage.removeItem("genome-patient-id");

    dispatch(storePatientSymptomsActionCreator([]));
    dispatch(storeFamilyBackgroundsActionCreator([]));
    dispatch(storePatientDiseasesActionCreator([]));

    dispatch(storePatientInitialStateActionCreator());
    dispatch(storeSearchInitialStateActionCreator());

    dispatch(storeUserFoundActionCreator());
  };

  const handleNewUser = () => {
    setNewPatient(true);
  };

  const sections = [
    {
      img: iconUserBlue,
      label: "patientInfo",
      component: <PatientInfoComponent handleNewUser={handleNewUser} />,
      disabled: false,
    },
    {
      img: iconRecord,
      label: "patientBackgrounds",
      component: <PatientBackgroundsComponent />,
      disabled: disableTabs,
    },
    {
      img: iconHeartBlue,
      label: "symptoms_and_signs",
      component: <PatientSymptomsComponent />,
      disabled: disableTabs,
    },
    {
      img: iconFamilyBlue,
      label: "familyBackground",
      component: <PatientFamilyBackgroundComponent />,
      disabled: disableTabs,
    },
    { img: iconDoc, label: "results", component: <PatientDiagnosisComponent />, disabled: disableTabs },
  ];

  const patientFormCallback = () => {
    localStorage.removeItem("genome-new-patient");
    setFormError(null);
    getPatientService(patientId, patientCallback, patientErrorCallback);
  };

  const patientFormErrorCallback = (error) => {
    if (error.response.status === HTTP_CODE_409 && !!error.response.data?.detail) {
      setFormError(error.response.data.detail);
    } else {
      showMessage(error);
    }
  };

  const patientInfoFunction = () => {
    const body = {
      patient_id: patientId,
      birth_date: !!birthDate ? new Date(birthDate).getTime() : null,
      gender: gender,
      birth_zip_code: +birthZipCode,
      residential_zip_code: +residentialZipCode,
      comments,
    };

    PATIENT_SCHEMA.validate(body)
      .then(() => {
        !!newPatient
          ? postCreateRecordService(body, patientFormCallback, patientFormErrorCallback)
          : patchUpdateRecordService(patientData.id, body, patientFormCallback);
      })
      .catch((error) => {
        const formattedError = renderFormError(error);
        setFormError(formattedError);
      });
  };

  const patientBackgroundsCallback = () => {
    dispatch(changePatientBackgroundsToRemoveAction([]));
    getPatientBackgrounds(patientData.id);
  };

  const patientBackgroundsFunction = () => {
    const putBody = selectedPatientBackgrounds.concat(patientBackgrounds).map((background) => {
      return {
        disease_id: background.id,
      };
    });

    putBody?.length > patientBackgrounds?.length &&
      putUpdatePatientBackgroundsService(patientData.id, putBody, patientBackgroundsCallback);

    !!patientBackgroundsToRemove?.length &&
      deletePatientBackgroundsService(patientData.id, patientBackgroundsToRemove, patientBackgroundsCallback);
  };

  const getSymptomsCallback = (response) => {
    dispatch(storePatientSymptomsActionCreator(response.data));
    dispatch(resetSelectionAction());
  };

  const getDiseasesCallback = (response) => {
    dispatch(storePatientDiseasesActionCreator(response.data));

    const diagnosis = response.data.filter((d) => d.is_diagnose) || [];
    dispatch(storePatientDiagnosisActionCreator(diagnosis));
    dispatch(resetSelectionAction());
  };

  const getFamilyBackgroundsCallback = (response) => {
    dispatch(storeFamilyBackgroundsActionCreator(response.data));
    dispatch(resetSelectionAction());
  };

  const getPatientBackgroundsCallback = (response) => {
    dispatch(storePatientBackgroundsActionCreator(response.data));
    dispatch(resetSelectionAction());
  };

  const symptomsCallback = () => {
    dispatch(changeSymptomsToRemoveAction([]));
    getSymptoms(patientData.id);
  };

  const patientSymptomsFunction = () => {
    const putBody = selectedSymptoms.concat(symptoms).map((symptom) => {
      return {
        symptom_id: symptom.id,
      };
    });

    putBody?.length > symptoms?.length && putUpdatePatientSymptomsService(patientData.id, putBody, symptomsCallback);

    !!symptomsToRemove?.length && deletePatientSymptomsService(patientData.id, symptomsToRemove, symptomsCallback);
  };

  const backgroundsCallback = () => {
    dispatch(changeFamilyBackgroundsToRemoveAction([]));
    getFamilyBackgrounds(patientData.id);
  };

  const familyBackgroundsFunction = () => {
    const putBody = selectedFamilyBackgrounds.concat(familyBackgrounds).map((disease) => {
      return {
        relative: disease.relative,
        inheritance: disease.inheritance,
        disease_id: disease.id,
      };
    });

    putBody?.length > familyBackgrounds?.length &&
      putUpdateFamilyBackgroundsService(patientData.id, putBody, backgroundsCallback);

    !!familyBackgroundsToRemove?.length &&
      deleteFamilyBackgroundsService(patientData.id, familyBackgroundsToRemove, backgroundsCallback);
  };

  const diseasesCallback = () => {
    dispatch(changeDiseasesToRemoveAction([]));
    getDiseases(patientData.id);
  };

  const patientDiseasesFunction = () => {
    const putBody = selectedDiseases.concat(diseases).map((disease) => {
      return {
        disease_id: disease.id,
      };
    });

    putBody?.length > diseases?.length && putUpdatePatientDiseasesService(patientData.id, putBody, diseasesCallback);

    !!diseasesToRemove?.length && deletePatientDiseasesService(patientData.id, diseasesToRemove, diseasesCallback);
  };

  const sendFormFunctions = () => {
    switch (tab) {
      case 0:
        return patientInfoFunction;
      case 1:
        return patientBackgroundsFunction;
      case 2:
        return patientSymptomsFunction;
      case 3:
        return familyBackgroundsFunction;
      case 4:
        return patientDiseasesFunction;
      default:
        return patientInfoFunction;
    }
  };

  const handleSendForm = () => {
    const submitFunction = sendFormFunctions();

    submitFunction();
  };

  const cancelPatientInfoFunction = () => {
    if (!!formError) {
      setFormError(null);
    }
    dispatch(storePatientInfoAction(patientData));
    dispatch(storePatientDiagnosisActionCreator(diagnosis || []));
  };

  const cancelPatientSymptomsFunction = () => {
    dispatch(cancelPatientSymptomsAction(symptoms));
  };

  const cancelFamilyBackgroundsFunction = () => {
    dispatch(cancelFamilyBackgroundsAction(familyBackgrounds));
  };

  const cancelPatientBackgroundsFunction = () => {
    dispatch(cancelPatientBackgroundsAction(patientBackgrounds));
  };

  const cancelPatientDiseasesFunction = () => {
    dispatch(cancelPatientDiseasesAction(diseases));
  };

  const cancelFormFunctions = () => {
    switch (tab) {
      case 0:
        return cancelPatientInfoFunction;
      case 1:
        return cancelPatientBackgroundsFunction;
      case 2:
        return cancelPatientSymptomsFunction;
      case 3:
        return cancelFamilyBackgroundsFunction;
      case 4:
        return cancelPatientDiseasesFunction;
      default:
        return cancelPatientInfoFunction;
    }
  };

  const handleResetForm = () => {
    const cancelFunction = cancelFormFunctions();

    cancelFunction();
  };

  const deleteCallback = () => {
    localStorage.removeItem("genome-patient-id");

    dispatch(storePatientInitialStateActionCreator());

    navigate(ROUTES_HOME);
  };

  const handleDeletePatient = () => {
    recordId && deleteRecordService(recordId, deleteCallback);
  };

  return (
    <>
      <div container className={classes.root}>
        <div className={`${classes.gridItem} ${classes.tabsPaper}`}>
          {!mobileVersion && <BackButtonComponent handler={handleGoBack} />}
          <Tabs
            orientation={mobileVersion ? "horizontal" : "vertical"}
            value={tab}
            variant="fullWidth"
            onChange={handleChange}
            TabIndicatorProps={{
              style: { display: "none" },
            }}
            className={classes.tabs}
          >
            {sections?.map((section, index) => (
              <Tab
                key={section.label}
                disabled={section.disabled}
                label={
                  <div className={classes.tab}>
                    <img src={section.img} alt={"Menu Icon"} />
                    {!mobileVersion && (
                      <Typography className={classes.tabLabel}>{intl.formatMessage({ id: section.label })}</Typography>
                    )}
                  </div>
                }
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
          {!mobileVersion && (
            <FormButtonGroupComponent
              onSave={handleSendForm}
              onCancel={handleResetForm}
              onDelete={handleSetOpenDeleteRecordModal}
              tab={tab}
            />
          )}
          {!!formError && (
            <div className={classes.formError}>
              <ErrorOutlineRoundedIcon />
              <Typography>{formError}</Typography>
            </div>
          )}
        </div>
        <div className={classes.panelPaper}>
          {sections?.map((section, index) => (
            <TabPanel value={tab} index={index} key={section.label}>
              {mobileVersion && <BackButtonComponent handler={handleGoBack} />}
              {section.component}
              {mobileVersion && (
                <FormButtonGroupComponent
                  onSave={handleSendForm}
                  onCancel={handleResetForm}
                  onDelete={handleSetOpenDeleteRecordModal}
                  tab={tab}
                />
              )}
            </TabPanel>
          ))}
        </div>
      </div>
      <AlertDialog
        maxWidth={"md"}
        open={openDeleteRecordModal}
        buttonCloseText={
          <Typography className={classes.firstCap}>{intl.formatMessage({ id: "global_buttons_close" })}</Typography>
        }
        description={
          <Typography>{intl.formatMessage({ id: "patientForm_delete_confirmation" }, { id: patientId })}</Typography>
        }
        title={
          <Typography variant={"h5"} className={classes.dialogTitle}>
            {intl.formatMessage({ id: "patientForm_delete" })}
          </Typography>
        }
        onClose={handleSetOpenDeleteRecordModal}
        dialogClassName={classes.dialogContent}
        buttonClassName={classes.secondaryButton}
        actionButton={
          <Button className={classes.primaryButton} onClick={handleDeletePatient}>
            <Typography className={classes.firstCap}>{intl.formatMessage({ id: "patientForm_delete" })}</Typography>
          </Button>
        }
      />
    </>
  );
};

export default withAuthorization(ROLES_ALL)(PatientComponent);
